/**
  * @class meleNotifications
  * @description
  *
  * # Purpose
  * Implements `<mele-notifications>` custom web element.
  *
  * # Use
  * Create element in HTML:
  * ```
  * parentEl.innerHTML += '<mele-notifications></mele-notifications>';
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-notifications',
  *   ... other attributes ...
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleList from 'meleList'

const PROPERTIES = _.extend({}, {
  open: { type: 'boolean', description: 'true to show all notifications, false to show only top one' },
}, meleList._properties)

export default class meleNotifications extends meleList {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Creates internal DOM structure.
  */
  init() {
    super.init()
    this._open_button = this._footer.appendChildren({
      tag: 'mele-button',
      key: 'opener',
      iconleft: '',
      eventButtonClicked: ()=>{ this.open = !this.open },
    })
    // this._setFooterEmptyFlag();
    this.openChanged(this.open)
  } // init

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * By default items are mele-notif
  */
  coerceItem(json) {
    if(typeof (json)==='string' || typeof (json)==='number') {
      // string definition is a shortcut for {key: json}
      json = { key: _.toString(json) }
    }
    if(_.isObjectLike(json)) {
      json = _.extend({
        tag: 'mele-notif',
        prefix: this.prefix,
        label: _.toString(this.label),
        label2: _.toString(this.label2),
        value: _.toString(this.value),
        iconleft: _.toString(this.iconleft),
        iconright: _.toString(this.iconright),
        color: _.toString(this.color),
        selected: _.toString(this.selected),
      }, json)
      return json
    }else{
      return null
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * update "open" button when form change (e.g. item is removed)
  */
  formStatusChanged() {
    super.formStatusChanged()
    this.openChanged(this.open)
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "open"
  */
  openChanged(value) {
    if(!this._open_button) return
    const count = this.items.length

    this.classList.toggle('noopener', count<2)
    if(count < 2) {
      this._open_button.iconleft = ''
    } else {
      if(value == true) {
        setTimeout(()=>{
          const el = this.findAll('mele-notif')
          this._footer.classList = el[el.length-1].classList[0]
        }, 10)
        this._open_button.iconleft = 'sys.dropdown.1'
      } else {
        setTimeout(()=>{
          const el = this.findAll('mele-notif')
          this._footer.classList = el[0].classList[0]
        }, 10)
        this._open_button.iconleft = 'sys.dropdown.0'
      }
    }
  } // openChanged
} // class meleNotifications

meleNotifications._properties = PROPERTIES
meleNotifications.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-notifications', meleNotifications)
